/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BookingIdRemarkRuleOrderValue,
    BookingIdRemarkRuleOrderValueFromJSON,
    BookingIdRemarkRuleOrderValueFromJSONTyped,
    BookingIdRemarkRuleOrderValueToJSON,
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface BookingIdRemarkRuleQuery
 */
export interface BookingIdRemarkRuleQuery {
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof BookingIdRemarkRuleQuery
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {boolean}
     * @memberof BookingIdRemarkRuleQuery
     */
    showDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BookingIdRemarkRuleQuery
     */
    showDeleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BookingIdRemarkRuleQuery
     */
    orderByDescending?: boolean;
    /**
     * 
     * @type {BookingIdRemarkRuleOrderValue}
     * @memberof BookingIdRemarkRuleQuery
     */
    orderValue?: BookingIdRemarkRuleOrderValue;
    /**
     * 
     * @type {number}
     * @memberof BookingIdRemarkRuleQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BookingIdRemarkRuleQuery
     */
    limit?: number | null;
}

export function BookingIdRemarkRuleQueryFromJSON(json: any): BookingIdRemarkRuleQuery {
    return BookingIdRemarkRuleQueryFromJSONTyped(json, false);
}

export function BookingIdRemarkRuleQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingIdRemarkRuleQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'showDisabled': !exists(json, 'showDisabled') ? undefined : json['showDisabled'],
        'showDeleted': !exists(json, 'showDeleted') ? undefined : json['showDeleted'],
        'orderByDescending': !exists(json, 'orderByDescending') ? undefined : json['orderByDescending'],
        'orderValue': !exists(json, 'orderValue') ? undefined : BookingIdRemarkRuleOrderValueFromJSON(json['orderValue']),
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function BookingIdRemarkRuleQueryToJSON(value?: BookingIdRemarkRuleQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'showDisabled': value.showDisabled,
        'showDeleted': value.showDeleted,
        'orderByDescending': value.orderByDescending,
        'orderValue': BookingIdRemarkRuleOrderValueToJSON(value.orderValue),
        'offset': value.offset,
        'limit': value.limit,
    };
}


